import classnames from 'classnames';
import React from 'react';
import styles from "./Progress.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_STROKE_WIDTH = 10;
export const getPathStyles = value => {
  const radius = 50 - DEFAULT_STROKE_WIDTH / 2;
  const length = Math.PI * 2 * radius;
  return `${value / 100 * length}px ${length}px`;
};
export const Progress = ({
  value: unroundedValue,
  circular,
  className,
  inverted
}) => {
  const classes = classnames(styles.progress, inverted && styles.inverted, className);
  const roundedValue = Math.round(unroundedValue);
  const value = roundedValue > 100 ? 100 : roundedValue < 0 ? 0 : roundedValue;
  const title = `${value}%`;
  if (circular) {
    return /*#__PURE__*/_jsxs("svg", {
      role: "progressbar",
      className: classes,
      viewBox: "0 0 100 100",
      children: [/*#__PURE__*/_jsx("title", {
        children: title
      }), /*#__PURE__*/_jsx("path", {
        fillOpacity: "0",
        strokeWidth: DEFAULT_STROKE_WIDTH,
        d: "M 50,50 m 0,-45 a 45,45 0 1 1 0,90 a 45,45 0 1 1 0,-90",
        strokeDasharray: "282.74px 282.74px"
      }), /*#__PURE__*/_jsx("path", {
        fillOpacity: "0",
        strokeWidth: DEFAULT_STROKE_WIDTH,
        d: "M 50,50 m 0,-45 a 45,45 0 1 1 0,90 a 45,45 0 1 1 0,-90",
        strokeDasharray: getPathStyles(value)
      })]
    });
  }
  return /*#__PURE__*/_jsx("progress", {
    className: classes,
    title: title,
    value: value,
    max: 100
  });
};